// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1aAXS","savePackageButton":"ClientWallet_savePackageButton__3fr1L"};